var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 139,
    viewBox: "0 0 203 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5938 29.2999L65.6072 36.81",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.555 29.2999L136.541 36.81",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4297 19.354L73.1039 28.3778",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.719 19.3538L129.045 28.3775",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3125 10.8314L81.4823 22.2307",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.836 10.8313L120.666 22.2305",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5625 7.27515L91.219 19.5068",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.906 4.76782L100.906 17.2846",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.164 1.04761L105.912 23.5773",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.586 7.27515L110.929 19.5068",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0391 20.098L73.1662 35.5952",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.117 20.0978L128.99 35.5949",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67 10.6711L80.1013 29.6936",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.148 10.671L122.047 29.6935",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8359 4.55457L88.7022 26.2714",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.312 4.55457L113.446 26.2714",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8984 1L96.3711 24.0927",
    stroke: "#1471D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8505 120.681H0.078125V112.893L33.0368 44.8099H50.1264V105.91H59.0781V120.681H50.1264V138.81H33.8505V120.681ZM33.8505 105.91V73.0099L19.0666 105.91H33.8505Z",
    fill: "#1471D2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0781 85.4587C75.0781 126.107 92.4115 143.528 109.745 137.721C115.113 135.923 127.078 128.43 127.078 114.493C127.078 97.0725 115.523 97.0725 115.523 85.4586C115.523 73.8447 121.3 73.8447 121.3 62.2308C121.3 50.6169 109.745 44.8099 103.967 44.8099C98.1892 44.8099 75.0781 44.81 75.0781 85.4587Z",
    fill: "#1471D2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M176.851 120.681H143.078V112.893L176.037 44.8099H193.126V105.91H202.078V120.681H193.126V138.81H176.851V120.681ZM176.851 105.91V73.0099L162.067 105.91H176.851Z",
    fill: "#1471D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.cd92fd9c58d8a4206a440f1fdc9fa4ac.svg";
export { ForwardRef as ReactComponent };